import React from 'react'
import PropTypes, { bool, func } from 'prop-types'

import * as Component from './Button.styles'

/**
 * Generic Button Component
 */
const Button = (props) => {
  const { id, className, text, disabled, onClick, icon, textFirst, ...other } =
    props

  return (
    <Component.DefaultButton
      id={ id }
      className={ `btn ${ className }` }
      onClick={ (e) => (onClick ? onClick(e.target) : null) }
      disabled={ disabled }
      aria-label={ text }
      { ...other }>
      {!textFirst && (
        <>
          {icon && icon}
          {text}
        </>
      )}

      {textFirst && (
        <>
          {text}
          {icon && icon}
        </>
      )}
    </Component.DefaultButton>
  )
}

Button.defaultProps = {
  disabled: false,
  className: 'btn-default',
  text: '',
  textFirst: false,
  onClick: false,
}

Button.propTypes = {
  /** The CSS class name of the input wrapper element. */
  className: PropTypes.string,
  // unique css identifier
  id: PropTypes.string,
  /** Button text */
  text: PropTypes.node.isRequired,
  /** enable or disable Button */
  disabled: PropTypes.bool,
  /** optional onCLick Handler */
  onClick: PropTypes.oneOfType([func, bool]),
  /** onCLick Handler */
  textFirst: PropTypes.bool,
}

export default Button
